import axios from "axios";
import { environment } from "../../../environments/environment";

export const getLocations = (page, pageSize, order, body, search) => {
  // return all Locations availables
  const params = new URLSearchParams();
  params.append("page", page.toString());
  params.append("pageSize", pageSize.toString());
  params.append("orderBy", order.toString());
  params.append("search", search);
  let filterArray = [
    
    {
      columnName: "accountId",
      value: [parseInt(localStorage.getItem("u_account_id"))],
    },
  ];
  return axios.post(environment.getLocations + params, body);
};

export const getLocationData = (locationId) => {
  // return a specific data about a location
  let params = new URLSearchParams();
  params.append("locationId", locationId);

  return axios.get(environment.getLocation + params);
};

export const saveLocation = () => {
  return axios.post(environment.saveLocation);
};

export const updateLocation = (body) => {
  return axios.put(environment.saveLocation, body);
};

export const deleteActiveLocation = (locationId) => {
  const params = new URLSearchParams();
  params.append("locationId", locationId);

  return axios.delete(environment.deleteLocation + params);
};

export const getSites = (page, pageSize, body , orderBy) => {
  const params = new URLSearchParams();
  params.append("page", page.toString());
  params.append("pageSize", pageSize.toString());
  params.append("orderBy", orderBy.toString());

  return axios.post(environment.getSites + params, body);
};

export const createSite = () => {
  return axios.post(environment.createSite, null);
};

export const updateSite = (body) => {
  return axios.put(environment.createSite, body);
};

export const getSite = (siteId) => {
  // used to get a specific site information
  let params = new URLSearchParams();
  params.append("id", siteId);

  return axios.get(environment.getSite + params);
};

export const deleteSite = (siteId) => {
  const params = new URLSearchParams();
  params.append("id", siteId.toString());
  return axios.delete(environment.deleteSite + params);
};

export const saveAircraftCompatibility = (body) => {
  return axios.post(environment.saveAircraftCompatibility, body);
};

export const deleteAircraftCompatibility = (id) => {
  let param = new URLSearchParams();
  param.append("id", id.toString());

  return axios.delete(environment.deleteAircraftCompatibility + param);
};
// racks
export const getRacks = (page, pageSize, body) => {
  const params = new URLSearchParams();
  params.append("page", page.toString());
  params.append("pageSize", pageSize.toString());

  return axios.post(environment.getRacks + params, body);
};

export const getRack = (rackId) => {
  // return the data of an specific rack
  let params = new URLSearchParams();
  params.append("id", rackId.toString());

  return axios.get(environment.getRack + params);
};

export const createRack = () => {
  return axios.post(environment.createRack);
};

export const deleteRack = (rackId) => {
  const params = new URLSearchParams();
  params.append("id", rackId.toString());

  return axios.delete(environment.deleteRack + params);
};

export const updateRack = (body) => {
  return axios.put(environment.updateRack, body);
};

// shelves services

export const createShelf = () => {
  return axios.post(environment.createShelf);
};

export const UpdateShelf = (body) => {
  return axios.put(environment.updateShelf, body);
};

export const DeleteShelf = (shelfId) => {
  let param = new URLSearchParams();
  param.append("id", shelfId.toString());
  return axios.delete(environment.deleteShelf + param);
};

export const getShelves = (page, pageSize, body) => {
  let param = new URLSearchParams();
  param.append("page", page.toString());
  param.append("pageSize", pageSize.toString());

  return axios.post(environment.getShelves + param, body);
};

export const getShelf = (id) => {
  let param = new URLSearchParams();
  param.append("id", id.toString());
  return axios.get(environment.getShelf + param);
};
// bins services

export const createBin = () => {
  return axios.post(environment.createBin);
};

export const UpdateBin = (body) => {
  return axios.put(environment.updateBin, body);
};

export const deleteBin = (binId) => {
  let param = new URLSearchParams();
  param.append("id", binId.toString());
  return axios.delete(environment.deleteBin + param);
};

export const getBins = (page, pageSize, orderBy, body) => {
  let param = new URLSearchParams();
  param.append("page", page.toString());
  param.append("pageSize", pageSize.toString());
  param.append("orderBy", orderBy);

  return axios.post(environment.getBins + param, body);
};

export const getBin = (id) => {
  let param = new URLSearchParams();
  param.append("id", id.toString());
  return axios.get(environment.getBin + param);
};
